import React from "react";
import IconSlide from '../../assets/images/icon/sliding-text-icon-1.png';

const SlidingTextOne = () => {
  const slidingTextItems = [
    // { title: "RAMANA STEEL", hoverText: "RAMANA STEEL" },
    // { title: "RAMANA INTERNATIONAL", hoverText: "RAMANA INTERNATIONAL", border: true },
    // { title: "RAMANA MACHINES", hoverText: "RAMANA MACHINES" },
    // { title: "RAMANA STEEL", hoverText: "RAMANA STEEL", border: true },
    // { title: "RAMANA INTERNATIONAL", hoverText: "RAMANA INTERNATIONAL" },
    { title: "WE DO NOT HAVE ANY SUBSIDIARIES", hoverText: "WE DO NOT HAVE ANY SUBSIDIARIES" },
    { title: "WE DO NOT HAVE ANY SUBSIDIARIES", hoverText: "WE DO NOT HAVE ANY SUBSIDIARIES" },
    { title: "WE DO NOT HAVE ANY SUBSIDIARIES", hoverText: "WE DO NOT HAVE ANY SUBSIDIARIES" },
    { title: "WE DO NOT HAVE ANY SUBSIDIARIES", hoverText: "WE DO NOT HAVE ANY SUBSIDIARIES" },
    { title: "WE DO NOT HAVE ANY SUBSIDIARIES", hoverText: "WE DO NOT HAVE ANY SUBSIDIARIES" },
  ];

  return (
    <section className="sliding-text-one">
      <div className="sliding-text-one__wrap">
        <ul className="sliding-text__list list-unstyled marquee_mode">
          {slidingTextItems.map((item, index) => (
            <li key={index}>
              <h4
                data-hover={item.hoverText}
                className={`sliding-text__title ${item.border ? "sliding-text__title-bdr" : ""}`}
              >
                {item.title}
                <svg width="30" height="22" viewBox="0 0 55 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="55" height="41" fill="none" />
                  <path d="M5 30 L20 10 L35 10 L50 30 L45 35 L10 35 Z" stroke="white" stroke-width="2" fill="white" />

                </svg>
              </h4>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SlidingTextOne;
